import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { WizardService } from '../../services/wizard.service'
import { WizardHeaderActions } from '../../types/wizard.type'
import { WizardBreadcrumbComponent } from '../wizard-breadcrumb/wizard-breadcrumb.component'

@Component({
  selector: 'wizard-header',
  templateUrl: './wizard-header.component.html',
  standalone: true,
  imports: [CommonModule, WizardBreadcrumbComponent]
})
export class WizardHeaderComponent {
  @Input() public breadcrumbs: string[] = []
  @Output('onClose') public close = new EventEmitter<void>()

  private readonly _wizardService = inject(WizardService)

  protected readonly headerActions = this._wizardService.headerActions

  /**
   * @description Emit a close event. Uses mousedown (not click) so handler runs before input blur,
   * allowing cancelPendingBlurSave to run before blur-save is scheduled (same pattern as navbar logo).
   */
  public onClose(event?: MouseEvent): void {
    event?.preventDefault()
    event?.stopPropagation()
    this.close.emit()
  }

  public onSaveMouseDown(event: MouseEvent, actions: WizardHeaderActions): void {
    event.preventDefault()
    event.stopPropagation()
    if (actions.saveDisabled || actions.saveLoading) return
    actions.onSave?.()
  }

  public onFeatureToggleChange(event: Event, actions: WizardHeaderActions): void {
    const enabled = (event.target as HTMLInputElement).checked
    actions.onFeatureToggle?.(enabled)
  }
}
